import classnames from 'classnames/bind'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'

import BannerImage from '~/components/UI/BannerImage'
import { ImageProps } from '~/components/UI/Image'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type HeroFilteredPageProps = {
  className?: string
  image?: ImageProps
  mobileImage?: ImageProps
  title?: string
  size?: 'big' | 'medium'
}

function HeroFilteredPage({
  className,
  image,
  mobileImage,
  title,
  size = 'medium',
}: HeroFilteredPageProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    textPreset:
      size === 'big'
        ? GlobalTextPreset.TitleFluid64_214SangBleu
        : GlobalTextPreset.TitleFluid38_144SangBleu,
  })

  return (
    <div className={cx(css.HeroFilteredPage, className)}>
      {(image || mobileImage) && (
        <BannerImage
          className={cx(css.bannerImage)}
          image={image}
          mobileImage={mobileImage}
        />
      )}
      {title && (
        <div className={cx(css.content, gridStyle)}>
          <h1 className={cx(css.title, titleStyle)}>{title}</h1>
        </div>
      )}
    </div>
  )
}

HeroFilteredPage.defaultProps = {}

export default HeroFilteredPage
